import { useState } from 'react';
import { PencilIcon } from '@heroicons/react/24/outline';
import type { Movimentacao } from '../../../models';
import { useMovimentacaoMutations } from '../../../hooks/data';
import { dataInputParaDate, timestampParaDataInput } from '../../../utils/dataInput';
import { paraDataFormatada } from '../../SolicitacoesListPage/components/solicitacoesKanban.utils';

interface DataPrevistaMovimentacaoProps {
  solicitacaoId: string;
  movimentacao: Movimentacao;
  /** SI ou quem abriu a Solicitação (inclui o time do DP) — mesma regra do firestore.rules
   * (`siAgeComoSolicitante`: só `dataPrevista`). */
  podeEditar: boolean;
}

/**
 * Data prevista desta Movimentação (cada uma tem a sua: o envio e a devolução de uma Troca
 * podem ser em dias diferentes). Antes ficava só no cabeçalho da Solicitação e editava só a
 * da 1ª Movimentação.
 */
export default function DataPrevistaMovimentacao({ solicitacaoId, movimentacao, podeEditar }: DataPrevistaMovimentacaoProps) {
  const { atualizarMovimentacao } = useMovimentacaoMutations(solicitacaoId);
  const [editando, setEditando] = useState(false);
  const [valor, setValor] = useState('');
  const rotulo = movimentacao.tipoFluxo === 'devolucao' ? 'Data prevista para devolução' : 'Data prevista';

  const abrir = () => {
    setValor(timestampParaDataInput(movimentacao.dataPrevista));
    setEditando(true);
  };

  const salvar = () => {
    // Campo vazio (o "x" do input nativo) salva null — desmarca data preenchida por engano.
    atualizarMovimentacao.mutate({ id: movimentacao.id, dataPrevista: valor ? (dataInputParaDate(valor) as any) : null });
    setEditando(false);
  };

  if (editando) {
    return (
      <div className="mt-1 flex flex-wrap items-center gap-2">
        <span className="text-xs text-gray-500">{rotulo}:</span>
        <input type="date" className="input-primary py-1 text-sm" value={valor} onChange={(event) => setValor(event.target.value)} />
        <button type="button" className="btn-secondary px-3 py-1 text-sm" onClick={salvar}>
          Salvar
        </button>
        <button type="button" className="text-sm text-gray-500 hover:text-gray-700" onClick={() => setEditando(false)}>
          Cancelar
        </button>
      </div>
    );
  }

  return (
    <p className="flex items-center gap-1.5 text-xs text-gray-500">
      {rotulo}: <span className="font-medium text-gray-700">{paraDataFormatada(movimentacao.dataPrevista) ?? 'a definir'}</span>
      {podeEditar && (
        <button type="button" className="text-gray-400 hover:text-gray-600" onClick={abrir} title={`Editar ${rotulo.toLowerCase()}`}>
          <PencilIcon className="h-3.5 w-3.5" />
        </button>
      )}
    </p>
  );
}
